import React from 'react';
import {
  Box,
  Inscription,
} from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { DEFAULT_DATE_FORMAT } from '@/common/constants';
import { Plan } from '@/modules/plan/plan.types.ts';
import { RenewalPlanYear } from '@/modules/Renewals/renewals.types.ts';

import PlanItem from './PlanItem';

interface Props {
  planYear?: RenewalPlanYear;
  plans?: Plan[];
  showPlansError?: boolean;
  isViewMode?: boolean;
  isEditMode?: boolean;
}

const PlansSummaryContainer: React.FC<Props> = ({
  planYear,
  plans,
  showPlansError,
  isViewMode,
  isEditMode,
}) => {
  if (!plans?.length) return null;
  return (
    <Box
      data-testid="plans-summary-container"
      gap="s"
    >
      <Box direction="row" align="center" justify="between">
        <Inscription size="medium" color="textBody">
          First and last date of plan year:
        </Inscription>
        <Inscription size="medium" color="textBody" weight="bold">
          {dayjs(planYear?.validFrom).format(DEFAULT_DATE_FORMAT)} - {planYear?.validTo ? dayjs(planYear?.validTo).format(DEFAULT_DATE_FORMAT) : ''}
        </Inscription>
      </Box>
      {
        plans.map((plan) => (
          <PlanItem
            key={plan.id}
            plan={plan}
            showPlansError={showPlansError}
            isViewMode={isViewMode}
            isEditMode={isEditMode}
          />
        ))
      }
    </Box>
  );
};

export default PlansSummaryContainer;
